const getUrl = rawUrl => {
  const url = rawUrl.replace('/', '')
  return `/${url}`
}

export default getUrl
